import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useTranslation } from '../../../common/hooks/useTranslation';
import {
  GetClientDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';

import { ContactTab } from './ContactTab';

interface ClientContactsModalEditorProps {
  clientId?: string;
  show: boolean;
  handleClose: () => void;
}

export const ClientContactsModalEditor: React.FC<
  ClientContactsModalEditorProps
> = props => {
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('clientLng');
  const [client, setClient] = useState<GetClientDto>();
  const { clientId } = props;

  useEffect(() => {
    if (!clientId) {
      setClient(undefined);
      return;
    }
    pok.clients
      .getById(clientId)
      .then(setClient)
      .catch(err => notifications.caughtError(err as ResponseError));
  }, [clientId, pok.clients, notifications]);

  return (
    <Modal show={props.show} onHide={props.handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {t(tk.client.clientContacts)}
          {client ? (
            <>
              : <b>{client.name}</b>
              {client.nip ? ` (${t(tk.client.nip)}: ${client.nip})` : ''}, nr
              sys. {client.systemNumber}
            </>
          ) : (
            ''
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {client && clientId && (
          <ContactTab clientId={clientId} client={client} />
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={props.handleClose}>
          {t(tk.button.close)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
